/*eslint-disable*/
import React from 'react';
// @mui/material components
import FeeFormComponent from './FeeForm';
export default function ValidationForms() {
  return <FeeFormComponent />;
}
